// Types pour le dashboard Overview
export interface OverviewFilters {
  solution: 'ssp' | 'adblock' | 'noconsent';
  period: 'yesterday' | 'last7days' | 'last30days' | 'lastMonth' | 'custom';
  customStartDate?: string; // Format YYYY-MM-DD
  customEndDate?: string;   // Format YYYY-MM-DD
  showVariation: boolean;
}

export interface NetworkRevenueData {
  networkId: number;
  networkName: string;
  bqKey: string;
  revenue: number;
  variation?: number; // Pourcentage de variation par rapport à la période précédente
  currency: string;
}

export interface WebsiteRevenueData {
  websiteName: string;
  revenue: number;
  variation?: number;
  currency: string;
}

export interface OverviewData {
  solution: 'ssp' | 'adblock' | 'noconsent';
  period: {
    startDate: string;
    endDate: string;
    label: string;
  };
  comparisonPeriod?: {
    startDate: string;
    endDate: string;
    label: string;
  };
  networks: NetworkRevenueData[];
  totalRevenue: number;
  totalVariation?: number;
  currency: string;
}

export interface WebsiteOverviewData {
  solution: 'ssp' | 'adblock' | 'noconsent';
  networkId: number;
  networkName: string;
  networkBqKey: string;
  period: {
    startDate: string;
    endDate: string;
    label: string;
  };
  comparisonPeriod?: {
    startDate: string;
    endDate: string;
    label: string;
  };
  websites: WebsiteRevenueData[];
  totalRevenue: number;
  totalVariation?: number;
  currency: string;
}

export interface OverviewApiResponse {
  success: boolean;
  data: OverviewData;
  error?: string;
}

export interface WebsiteOverviewApiResponse {
  success: boolean;
  data: WebsiteOverviewData;
  error?: string;
}

// Utility types
export type SolutionType = OverviewFilters['solution'];
export type PeriodType = OverviewFilters['period'];

// Enum pour les solutions (pour faciliter l'usage)
export const SOLUTIONS = {
  SSP: 'ssp' as const,
  ADBLOCK: 'adblock' as const,
  NOCONSENT: 'noconsent' as const,
} as const;

// Enum pour les périodes
export const PERIODS = {
  YESTERDAY: 'yesterday' as const,
  LAST_7_DAYS: 'last7days' as const,
  LAST_30_DAYS: 'last30days' as const,
  LAST_MONTH: 'lastMonth' as const,
  CUSTOM: 'custom' as const,
} as const;